import { SearchInput } from 'common/components/cookbook/Search/SearchInput';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useSetSearch } from 'common/hooks/useSetSearch';
import { isValidSearch } from 'common/utils/searchUtils';

import { vendorsLayoutRoute } from '..';

const SEARCH_INPUT_DEBOUNCE_DELAY_MS = 500;

export function VendorsSearchInput() {
  const formatMessage = useFormatMessage();
  const { search = '' } = vendorsLayoutRoute.useSearch();
  const setSearch = useSetSearch(vendorsLayoutRoute);

  const handleSearchChange = (value: string) => {
    setSearch({
      page: undefined,
      search: isValidSearch(value) ? value : undefined,
    });
  };

  return (
    <SearchInput
      debounceDelay={SEARCH_INPUT_DEBOUNCE_DELAY_MS}
      placeholder={formatMessage('vendors.search_vendors')}
      value={search}
      onChange={handleSearchChange}
      data-test-id="vendor-search-input"
      clearButtonAriaLabel={formatMessage('vendors.clear_vendors_search')}
      aria-label={formatMessage('vendors.search_vendors')}
    />
  );
}
